import client from "./Client";

const getStudentsInClass = (page, rows, search, class_id, type) => {
  const params = {};
  if (page >= 0) {
    params.page = page;
  }
  if (rows >= 0) {
    params.rows = rows;
  }
  if (search) {
    params.search = search;
  }
  if (type) {
    params.type = type;
  }

  params.active = 'Yes';

  return client.get(`/school/class/${class_id}/students`, {
    params,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const studentSignin = (regNo, password) =>
  client.post(
    `/signin`,
    {
      regNo,
      password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

const getAssessmentStat = (school_id, student_id) =>
  client.get(
    `/school/${school_id}/term-assessment/student/${student_id}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

const getStudentClassCurrentTermRating = (school_id, student_id, class_id) =>
  client.get(
    `/school/${school_id}/current-term-rating/student/${student_id}/class/${class_id}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

const getStudentCurrentSessionAssessment = (school_id, student_id) =>
  client.get(
    `/school/${school_id}/current-session-assessment/student/${student_id}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

const getSessionTermlyAssessment = (school_id, student_id) =>
  client.get(
    `/school/${school_id}/termly-assessment/student/${student_id}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

const updatePassword = (
  student_id = "",
  school_id,
  current_password = "",
  new_password = "",
  confirm_password = ""
) =>
  client.post(
    `/settings/password/update`,
    {
      student_id,
      school_id,
      current_password,
      new_password,
      confirm_password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

export default {
  getSessionTermlyAssessment,
  getStudentsInClass,
  studentSignin,
  getAssessmentStat,
  getStudentCurrentSessionAssessment,
  getStudentClassCurrentTermRating,
  updatePassword,
};
